"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./ClientForm"));
var ReferralForm_1 = require("./ReferralForm/ReferralForm");
exports.ReferralForm = ReferralForm_1.default;
//# sourceMappingURL=index.js.map